import { render, staticRenderFns } from "./AwardList.vue?vue&type=template&id=6e1216e7&scoped=true"
import script from "./AwardList.vue?vue&type=script&lang=js"
export * from "./AwardList.vue?vue&type=script&lang=js"
import style0 from "./AwardList.vue?vue&type=style&index=0&id=6e1216e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1216e7",
  null
  
)

export default component.exports